import { FunctionComponent, memo } from 'react'
import { ColorfulProgress, Box, useTheme, Text } from '@maas-components/core'
import { generateId } from 'utils/generate-id'

type TAppLoadingProps = {
  message: string
}

const AppLoading: FunctionComponent<TAppLoadingProps> = ({ message = '' }: TAppLoadingProps) => {
  const theme = useTheme()
  return (
    <Box
      id={generateId('app-loading-container', 'app')}
      alignItems="center"
      bgcolor="transparent"
      display="flex"
      height="100vh"
      justifyContent="center"
      flexDirection="column"
      gridGap={8}
      zIndex={theme.zIndex.drawer + 1}
    >
      <ColorfulProgress size={60} />
      <Text id={generateId('app-loading-text', 'app')} fontSize="medium">
        {message}
      </Text>
    </Box>
  )
}

export default memo(AppLoading)
